import { CONFIG } from "./config";

export const SOFTWARECOMPANYNAME = 'Fores GmbH'
export const VERSION = "Version 2.4.2";

export const DFTLNGCODE =  CONFIG.DFTLNGCODE;
export const URL = CONFIG.URL;
export const PAYMENTSERVER = CONFIG.PAYMENTSERVER;
export const VENDORID = CONFIG.VENDORID;
export const IMAGEURL = CONFIG.IMAGEURL;
export const PAYMENTSYSTEM = CONFIG.PAYMENTSYSTEM;
export const BANNER = CONFIG.BANNER;
export const BRANDS = CONFIG.BRANDS;
export const FLAG_ITEM_ON_HAND = CONFIG.FLAG_ITEM_ON_HAND;

//theme
export const MENU_LOGO_BACKGROUND = CONFIG.MENU_LOGO_BACKGROUND;
export const LOGO_LOGIN_BACKGROUND = CONFIG.LOGO_LOGIN_BACKGROUND;
export const MENU_WHITE_BACKGROUND = CONFIG.MENU_WHITE_BACKGROUND;

//color
export const COMPANY_PRIMARY_COLOR = CONFIG.COMPANY_PRIMARY_COLOR;

export function setCurrency(currency){
    sessionStorage.setItem("currency",currency)
  }

export const getCurrency = ()=>{
return sessionStorage.getItem("currency")??"";
}

export function setDecimalDigits(decimalDigits){
    sessionStorage.setItem("decimalDigits",decimalDigits)
  }

export const getDecimalDigits = ()=>{
return sessionStorage.getItem("decimalDigits")??2;
}
